// ==========================================
// 🛡️ SENTRY INITIALIZATION
// ==========================================
import * as Sentry from "@sentry/browser";

// Initialize Sentry early to catch all possible errors during page load
Sentry.init({
  // Use environment variables for security and dynamic environment switching
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,

  // Adjust the sample rate for production to avoid exhausting quota (e.g., 0.1 for 10%)
  tracesSampleRate: 1.0,

  // Privacy and compliance controls
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below.
    // For more info visit: https://docs.sentry.io/platforms/javascript/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  },
});

import "./bootstrap";
import "simple-datatables/dist/style.css";

import axios from "axios";
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// ==========================================
// 🏢 CLIENT COMPONENTS
// ==========================================
import Alpine from "alpinejs";
import loginForm from "./client/auth/loginForm";
import profileController from "./client/profile/profileController";
import landingController from "./components/landingController";
import bookingForm from "./components/bookingForm";
import clientLayoutController from "./client/controllers/clientLayoutController";
import dashboardControllerClient from "./client/dashboard/dashboardController";
import accessController from "./client/access/accessController";
import serviceListController from "./client/services/serviceListController";
import productListController from "./client/products/productListController";
import paymentMethodListController from "./client/paymentMethods/paymentMethodListController";
import scheduleSettingsController from "./client/scheduleSettings/scheduleSettingsController";
import appointmentListController from "./client/appointments/appointmentListController";
import posController from "./client/pos/posController";
import serviceOrderHistoryController from "./client/serviceOrders/serviceOrderHistoryController";
import clientListController from "./client/clients/clientListController";
import stockListController from "./client/stock/stockListController";
import checkoutController from "./client/checkout/checkoutController";
import subscriptionController from "./client/subscriptions/subscriptionController";

// ==========================================
// 🏢 FINANCIAL COMPONENTS
// ==========================================
import costCenterListController from "./financial/costCenterListController";
import categoryListController from "./financial/categoryListController";
import bankAccountListController from "./financial/bankAccountListController";
import supplierListController from "./financial/supplierListController";
import transactionListController from "./financial/transactionListController";

// ==========================================
// 🏢 REPORTS
// ==========================================
import commissionReportController from "./reports/commissionReportController";
import revenueReportController from "./reports/revenueReportController";
import cashFlowReportController from "./reports/cashFlowReportController";
import performanceReportController from "./reports/performanceReportController";
import criticalStockReportController from "./reports/criticalStockReportController";

// ==========================================
// 🌐 PUBLIC COMPONENTS (ESTÚDIOHUB)
// ==========================================
import bookingWizardController from "./public/bookingWizardController";
import registerController from "./public/registerController";
import pricingController from "./public/pricingController";
import contactController from "./public/contactController";
import forgotPasswordForm from "./public/forgotPasswordForm";
import resetPasswordForm from "./public/resetPasswordForm";

// ==========================================
// 🛠️ ADMIN COMPONENTS (ESTÚDIOHUB ROOT)
// ==========================================
import adminLoginForm from "./admin/auth/loginForm";
import adminLayoutController from "./admin/controllers/adminLayoutController";
import dashboardController from "./admin/dashboard/dashboardController";
import planListController from "./admin/plans/planListController";
import permissionListController from "./admin/permissions/permissionListController";
import adminUserController from "./admin/users/adminUserController";
import tenantListController from "./admin/tenants/tenantListController";
import settingsController from "./admin/settings/settingsController";

window.Alpine = Alpine;

// ==========================================
// 🏢 CLIENT COMPONENTS (BARBEARIA)
// ==========================================
Alpine.data("loginForm", loginForm);
Alpine.data("profileController", profileController);
Alpine.data("landingController", landingController);
Alpine.data("bookingForm", bookingForm);
Alpine.data("clientLayoutController", clientLayoutController);
Alpine.data("dashboardController", dashboardControllerClient);
Alpine.data("accessController", accessController);
Alpine.data("serviceListController", serviceListController);
Alpine.data("productListController", productListController);
Alpine.data("paymentMethodListController", paymentMethodListController);
Alpine.data("scheduleSettingsController", scheduleSettingsController);
Alpine.data("appointmentListController", appointmentListController);
Alpine.data("posController", posController);
Alpine.data("serviceOrderHistoryController", serviceOrderHistoryController);
Alpine.data("clientListController", clientListController);
Alpine.data("stockListController", stockListController);
Alpine.data("checkoutController", checkoutController);
Alpine.data("subscriptionController", subscriptionController);

// ==========================================
// 🏢 FINANCIAL COMPONENTS
// ==========================================
Alpine.data("costCenterListController", costCenterListController);
Alpine.data("categoryListController", categoryListController);
Alpine.data("bankAccountListController", bankAccountListController);
Alpine.data("supplierListController", supplierListController);
Alpine.data("transactionListController", transactionListController);

// ==========================================
// 🏢 REPORTS COMPONENTS
// ==========================================
Alpine.data("commissionReportController", commissionReportController);
Alpine.data("revenueReportController", revenueReportController);
Alpine.data("cashFlowReportController", cashFlowReportController);
Alpine.data("performanceReportController", performanceReportController);
Alpine.data("criticalStockReportController", criticalStockReportController);

// ==========================================
// 🌐 PUBLIC COMPONENTS (ESTÚDIOHUB)
// ==========================================
Alpine.data("bookingWizardController", bookingWizardController);
Alpine.data("registerController", registerController);
Alpine.data("pricingController", pricingController);
Alpine.data("contactFormController", contactController);
Alpine.data("forgotPasswordForm", forgotPasswordForm);
Alpine.data("resetPasswordForm", resetPasswordForm);

// ==========================================
// 🛠️ ADMIN COMPONENTS (ESTÚDIOHUB ROOT)
// ==========================================
Alpine.data("adminLoginForm", adminLoginForm);
Alpine.data("adminLayoutController", adminLayoutController);
Alpine.data("adminDashboard", dashboardController);
Alpine.data("planListController", planListController);
Alpine.data("permissionListController", permissionListController);
Alpine.data("adminUserController", adminUserController);
Alpine.data("tenantListController", tenantListController);
Alpine.data("settingsController", settingsController);

Alpine.start();
